import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
export default function FaqStittsville() {
  const faqs = [{
    question: "How much does junk removal in Stittsville cost?",
    answer: "Our pricing is based on the volume your items occupy in our truck. We provide free, no-obligation on-site estimates to ensure you only pay for the space you use."
  }, {
    question: "Do you offer same-day service for local residents?",
    answer: "Yes, we frequently offer same-day or next-day pickups in Stittsville and surrounding areas like Fairwinds and Blackstone to help you clear clutter quickly."
  }, {
    question: "What items are you unable to take?",
    answer: "While we take almost anything from furniture to appliances, we cannot accept hazardous materials such as chemicals, gasoline, or asbestos due to safety regulations."
  }, {
    question: "Do you recycle or donate the items you collect?",
    answer: "Absolutely. We prioritize sustainability by sorting through every load to donate usable items to local charities and ensuring recyclables are processed correctly."
  }, {
    question: "Which Stittsville neighborhoods do you cover?",
    answer: "We serve the entire Stittsville community, including Amberwood Village, Wyldewood, and the newer developments along Robert Grant Avenue."
  }];
  return <section data-section-id="222510" id="faq-stittsville" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold uppercase tracking-tighter text-foreground">
            Common Questions
          </h2>
          <p className="mt-4 text-muted-foreground font-sans max-w-2xl mx-auto text-lg">
            Everything you need to know about our professional junk removal
            services in the Stittsville area.
          </p>
        </div>

        <div className="relative border border-border bg-card/30 backdrop-blur-sm p-6 md:p-10 rounded-lg shadow-lg">
          {}
          <div className="absolute -top-3 left-6 md:left-10 bg-background px-2">
            <Badge variant="outline" className="uppercase tracking-widest text-xs font-default font-semibold border-primary/30 text-primary">
              FAQ
            </Badge>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-b border-border/50 last:border-0 group">
                <AccordionTrigger className="hover:no-underline hover:bg-accent/50 px-4 py-6 transition-colors duration-300 rounded-md">
                  <h4 className="font-default text-lg md:text-xl font-semibold text-left text-foreground group-hover:text-primary transition-colors">
                    {faq.question}
                  </h4>
                </AccordionTrigger>
                <AccordionContent className="px-4 pb-6 font-sans text-muted-foreground text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}